import {Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import JSZip from 'jszip';
import html2canvas from 'html2canvas';
import {BaseStateReportWidget} from '../base-state-report-widget';

@Component({
  selector: 'tgrid-coverage-overview-widget',
  templateUrl: './coverage-overview-widget.component.html',
  styleUrls: ['./coverage-overview-widget.component.scss'],
  imports: [MatCardModule, MatButtonModule, VulcanIconComponent],
})
export class CoverageOverviewWidgetComponent extends BaseStateReportWidget {
  protected override async export(): Promise<void> {
    const filename = `coverage_overview_${this.stateParam()}`;
    const zip = new JSZip();

    const textContent = this.exportContent()?.nativeElement.innerText;
    const textBlob = new Blob([textContent], {type: 'text/plain'});
    zip.file(`${filename}.txt`, textBlob);

    try {
      const canvas = await html2canvas(this.exportContent()?.nativeElement);
      const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve));
      if (blob) {
        zip.file(`${filename}.png`, blob);
        const content = await zip.generateAsync({type: 'blob'});
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.zip`;
        link.click();
        URL.revokeObjectURL(url);
      }
      this.snackBar.open('Export downloaded successfully', 'Close', { duration: 3000 });
    } catch (err) {
      console.error(err);
      this.snackBar.open('Export failed. Please try again.', 'Close', { duration: 3000 });
    }
  }
}
